import { render } from "./google.vue?vue&type=template&id=5acd5f8c"
import script from "./google.vue?vue&type=script&lang=js"
export * from "./google.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__